import React from "react";
import { useNavigate } from "react-router-dom";
import Topbg from "./Topbg";
import OpenPositions from "./OpenPositions";
import WhyJoinUs from "./WhyJoinUs";

const Careers = () => {
  const navigate = useNavigate();

  return (
    <>
      <Topbg />

      <div className="bg-gray-100 container mx-auto px-4 py-8 w-full">
        <div className="w-full mx-auto grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
          {/* Left Section - Title */}
          <div className="flex justify-start items-start text-left">
            <h2 className="text-5xl font-bold text-gray-900 leading-tight">
              Build your future with <br /> us.{" "}
              <span className="text-black">Literally</span>
            </h2>
          </div>

          {/* Right Section - Paragraph */}
          <div>
            <p className="text-gray-700 text-lg leading-relaxed">
              At Bricknbar, we’re not just transforming the building materials
              industry — we’re building a team that's passionate, driven, and
              ready to reshape how construction gets done across India. Whether
              you’re a logistics wizard, a sales superstar, a tech innovator, or
              someone who just loves making things better — we’ve got a place
              for you.
            </p>
          </div>
        </div>
      </div>

      <OpenPositions />
      <WhyJoinUs />
      <div className="bg-blue-50 py-12 px-4 rounded-lg text-center">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-800 mb-4">
          Don't see a role that fits?
        </h2>
        <p className="text-gray-700 max-w-2xl mx-auto text-xl">
          We're always looking for passionate people. Drop us an email at
          <a
            href="mailto:careers@bricknbar.com"
            className="text-blue-600 hover:text-blue-800 font-medium"
          >
            {" "}
            [careers@bricknbar.com]
          </a>{" "}
          with your resume and a short note about how you can contribute. We'd
          love to hear from you!
        </p>
      </div>
    </>
  );
};
export default Careers;
